import { render } from "./TaskBlock.vue?vue&type=template&id=7a715785"
import script from "./TaskBlock.vue?vue&type=script&lang=js"
export * from "./TaskBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__